import type { BadgeVariant } from "../../components/Badge";

// Maps an edge_agents.status value to a read-only badge tone. 'revoked'/'offline' read as
// problems (warn) so an ops-driven revoke is visible; 'pending' is in-progress, 'disabled'
// is a deliberate pause.
const STATUS_VARIANTS: Record<string, BadgeVariant> = {
  online: "success",
  pending: "accent",
  offline: "warn",
  revoked: "warn",
  disabled: "neutral",
};

export const edgeAgentStatusVariant = (status: string): BadgeVariant =>
  STATUS_VARIANTS[status] ?? "neutral";
